import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";

// Configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyD0j8D3PUqHgS2E4_uH77LkOJJlLW0gzS4",
  authDomain: "apimys-8da15.firebaseapp.com",
  projectId: "apimys-8da15",
  storageBucket: "apimys-8da15.firebasestorage.app",
  messagingSenderId: "226695915136",
  appId: "1:226695915136:web:d1659017f3727d683fe865",
  measurementId: "G-X6QV52QBLV"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);

// Inicializa servicios
export const auth = getAuth(app);
export const db = getFirestore(app);
export const messaging = getMessaging(app);
export { storage };

// Función para registrar el Service Worker y obtener el token FCM
export const registerServiceWorkerAndGetToken = async () => {
  try {
    // Solicita permiso para mostrar notificaciones al usuario
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Permiso de notificaciones no concedido por el usuario.");
      return null;
    }

    // Registra el Service Worker para Firebase Messaging
    const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
  

    // Obtén el token FCM usando el Service Worker registrado
    const currentToken = await getToken(messaging, {
      vapidKey: "BHs7BcXobNlY8tdmMYov5-_Q1IOFPbHtsnzpbPfRZrI4RClavJ60bj6Q5cT0aMRC2jHtYjLx_G5zmKFb3U0BUp4", // Reemplaza con tu clave pública VAPID desde Firebase Console
      serviceWorkerRegistration: registration,
    });

    if (currentToken) {
      return currentToken;
    } else {
      console.warn("No se pudo obtener el token FCM. Solicita permiso al usuario.");
      return null;
    }
  } catch (error) {
    console.error("Error al registrar el Service Worker o al obtener el token FCM:", error);
    throw error;
  }
};

// Escucha mensajes recibidos en primer plano
onMessage(messaging, (payload) => {
  console.log("Mensaje recibido en primer plano:", payload);
});
